import { useInfiniteQuery } from '@tanstack/react-query';
import { searchVehicleRemoteCommands } from '../api/searchVehicleRemoteCommands';
import { HISTORY_PAGE_SIZE, remoteCommandKeys } from '../constants';

/** Cursor of the next page: the last loaded id, or undefined (no more) after a short page. */
export const nextHistoryCursor = (lastPage) => {
	if (!Array.isArray(lastPage) || lastPage.length < HISTORY_PAGE_SIZE) return undefined;
	return lastPage[lastPage.length - 1].id;
};

/**
 * The unit's command history, HISTORY_PAGE_SIZE at a time, newest first
 * (keyset pagination with `beforeId`). Refetched every time the tab mounts.
 * `loadMore()` is safe to call repeatedly: it only fetches when there is a
 * next page and none is in flight.
 */
export const useRemoteCommandHistory = (unitId) => {
	const query = useInfiniteQuery({
		queryKey: remoteCommandKeys.history(unitId),
		queryFn: ({ pageParam }) => searchVehicleRemoteCommands(unitId, HISTORY_PAGE_SIZE, pageParam),
		initialPageParam: null,
		getNextPageParam: nextHistoryCursor,
		enabled: Boolean(unitId),
		staleTime: 0,
	});
	const commands = query.data?.pages.flat() ?? [];

	const loadMore = () => {
		if (!query.hasNextPage || query.isFetchingNextPage || query.isFetching) return;
		query.fetchNextPage();
	};

	return { query, commands, loadMore };
};
